import React, { useContext } from 'react';
import Spreadsheet from 'react-spreadsheet';

import { ChillerLogsContext } from '../contexts/ChillerLogsContext';

import { useFormattedTableData, updateChillerLogFieldIfChanged } from '../../../utils/highlightedDataUtil';

import { ChillerLog } from '../../model';

interface ManufacturerDetailsSubSectionProps {
  sectionChillerLog: ChillerLog;
  col: number;
}

const ManufacturerDetailsSubSection: React.FunctionComponent<ManufacturerDetailsSubSectionProps> = (props) => {
  let { sectionChillerLog, col } = props;

  let { chillerLog, setChillerLog, saveCurrentLogToLocalStorage, currentLogApproved } = useContext(ChillerLogsContext);

  const handleSpreadsheetChange = (updatedData) => {
    updateChillerLogFieldIfChanged({
      chillerLog,
      setChillerLog,
      updatedData,
      getField: () => sectionChillerLog?.manufacturer_details,
      setField: (log, value) => {
        log.manufacturer_details = value;
      },
    });
  };

  let tableData = useFormattedTableData(sectionChillerLog?.manufacturer_details, col, currentLogApproved);
  let columnLabels = ['', '', '', ''];

  return (
    <Spreadsheet
      data={tableData}
      hideRowIndicators
      columnLabels={[columnLabels[col]]}
      onChange={handleSpreadsheetChange}
      className={col === 3 ? 'chiller-spreadsheet third-column' : 'chiller-spreadsheet'}
      onBlur={saveCurrentLogToLocalStorage}
    />
  );
};

export default ManufacturerDetailsSubSection;
